<div class="center-container">

  <div class="search-container-inner">
      <mat-form-field ngSubmit="onSubmit()" appearance="fill" color="primary" class="search-bar">
        <mat-label>Hi {{userFirstName}}, what do you want to do today?</mat-label>
        <input matInput type="text" placeholder="Start typing to search..." [formControl]="taskSearchControl" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let task of filteredTasks | async" [value]="task">
            {{task}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <button (click)="onSubmit()" mat-raised-button color="accent" class="go-button">Go</button>
  </div>

</div>
